<app-user-product-details-component [productId]="productId()" />
